<template>
<b-modal id="modal-org-edit" size="lg" centered title="Edit Organisation" ok-title="Save" :ok-disabled="saving || !form.name" @ok="handleSave">
    <b-form>
        <div class="row">
            <div class="col-md-6">
                <b-form-group label="Name *">
                    <b-form-input v-model="form.name" placeholder="Organisation name"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Registration Number">
                    <b-form-input v-model="form.registration_number"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Website">
                    <b-form-input v-model="form.website" placeholder="https://"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Country">
                    <b-form-input v-model="form.country"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group label="Address">
                    <b-form-input v-model="form.address"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Contact Email">
                    <b-form-input v-model="form.contact.email" type="email"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-6">
                <b-form-group label="Contact Phone">
                    <b-form-input v-model="form.contact.phone"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group label="Expertise Areas" description="Comma separated, e.g. audit, legal">
                    <b-form-input v-model="expertiseText"></b-form-input>
                </b-form-group>
            </div>
            <div class="col-md-12">
                <b-form-group label="Bio">
                    <b-form-textarea v-model="form.bio" rows="4"></b-form-textarea>
                </b-form-group>
            </div>
        </div>
    </b-form>
</b-modal>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

const emptyForm = () => ({
    name: '',
    registration_number: '',
    website: '',
    country: '',
    address: '',
    bio: '',
    contact: { email: '', phone: '', address: '' }
});

export default {
    name: 'SpOrganisationEditModal',

    data() {
        return {
            orgId: null,
            form: emptyForm(),
            expertiseText: '',
            saving: false
        };
    },

    methods: {
        open(org) {
            this.orgId = org.id;
            this.form = {
                name: org.name || '',
                registration_number: org.registration_number || '',
                website: org.website || '',
                country: org.country || '',
                address: org.address || '',
                bio: org.bio || '',
                contact: { ...emptyForm().contact, ...(org.contact || {}) }
            };
            this.expertiseText = (org.expertise_areas || []).join(', ');
            this.$bvModal.show('modal-org-edit');
        },

        handleSave(event) {
            event.preventDefault();
            this.saving = true;

            const organisation = {
                ...this.form,
                expertise_areas: this.expertiseText.split(',').map(s => s.trim()).filter(Boolean)
            };

            this.$store.dispatch('skilledProfessional/editOrganisation', {
                id: this.orgId,
                organisation
            }).then(response => {
                Swal.fire({
                    title: response.code == 200 ? 'Success!' : 'Error!',
                    text: response.response,
                    icon: response.code == 200 ? 'success' : 'error'
                });
                if (response.code == 200) {
                    this.$bvModal.hide('modal-org-edit');
                    this.$emit('saved', response.data);
                }
            }).finally(() => {
                this.saving = false;
            });
        }
    }
};
</script>
